module.exports = __webpack_public_path__ + "img/signature@2x.dd4e35d.webp";